<template>
  <div id="DesktopView">
    <div class="Box">
      <img class="logo" src="@/assets/img/PeakLogo2.png" alt="" />
      <p>ขออภัย กรุณาเปิด LINE ในโทรศัพท์มือถือ</p>
      <p>Sorry, please open LINE on your mobile phone.</p>
      <img class="page404" src="@/assets/img/pageLineDesktop.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
#DesktopView {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: -85px;
  // padding: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: linear-gradient(121deg, #6c6df2 -18%, #44e5e6 100%);
  .Box {
    text-align: center;
    background: white;
    width: 70%;
    padding: 40px 40px 70px 40px;
    border-radius: 6px;
    @include shadowboxLv1;
    img.logo {
      margin-bottom: 30px;
    }
    img.page404 {
      height: 250px;
      margin: 40px 0px;
    }
    span {
      cursor: pointer;
    }
  }
  @media only screen and (max-width: 600px) {
    .Box {
      width: 90%;
      padding: 40px 20px;
      img.logo {
        width: 100%;
        max-width: 200px;
      }
      img.page404 {
        height: unset;
        width: 100%;
        max-width: 300px;
      }
    }
  }
  &::v-deep {
    body {
      padding-bottom: 0rem;
    }
  }
}
</style>
